import { Heading, Text } from "@chakra-ui/react";
import NextImage from "next/image";
import { useEffect } from "react";

import { sendINLeadConversion } from "helpers/conversions";
import CustomLink from "components/Chakra/CustomLink";
import CardLayout from "./CardLayout";
import { useTracking } from "contexts/Tracking";

const IdealniNajemceBanner: React.FC = () => {
  const { trackEvent } = useTracking();

  useEffect(() => {
    trackEvent({
      "dl.eCat": "moje_inzeraty",
      "dl.eAct": "dialog.shown",
      "dl.eLab": "Idealni najemce",
    });
  }, []);

  return (
    <CardLayout
      mt="22px"
      backgroundColor="ud-white"
      topImage={
        <>
          <NextImage
            src="/img/common/logo_in.svg"
            alt="Ideální nájemce"
            width="110"
            height="24"
            style={{
              position: "absolute",
              zIndex: 2,
              top: "20px",
              left: "20px",
            }}
          />
          <NextImage
            priority
            src="/img/email/in/in.png"
            alt="Ilustrační obrázek"
            fill
            style={{
              transition: "all 0.2s",
            }}
          />
        </>
      }
      content={
        <>
          <Heading as="h3" variant="h3_2">
            Pronajímejte bez starostí
          </Heading>
          <Text variant="small_2" textAlign="center" p="8px 0 28px">
            Více než <b>2 100</b> majitelům bytů šetříme peníze, čas i starosti.
          </Text>
          <CustomLink
            variant="button"
            href="https://idealninajemce.cz/ulovdomov-lps/idealni-najemce"
            w="100%"
            trackEventPayload={{
              "dl.eCat": "moje_inzeraty",
              "dl.eAct": "bttn.clicked",
              "dl.eLab": "Více o službě",
            }}
            onClick={() => {
              sendINLeadConversion("my_offers");
              trackEvent({
                "dl.eCat": "moje_inzeraty",
                "dl.eAct": "lead",
                "dl.eLab": "Idealni najemce",
              });
            }}
          >
            Více o službě
          </CustomLink>
        </>
      }
    />
  );
};

export default IdealniNajemceBanner;
